import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateInvoiceRequestV3 } from '@payer-admin-ui/api/src/invoices/requests/CreateInvoiceRequestV3';
import { invoiceAPI } from 'redux/invoiceAPI';
import { FetchingState } from '@payer-admin-ui/components-v2/src/types/state';
import { MerchantAdminState } from '../../../../redux/store';

export const getInvoicePreviewPdf = createAsyncThunk<
  string,
  { invoice: CreateInvoiceRequestV3 },
  { state: MerchantAdminState }
>('invoices/getInvoicePreviewPdf', async ({ invoice }) => {
  const blob = await invoiceAPI.getInvoicePreviewPdf(invoice);
  return URL.createObjectURL(blob);
});

type InvoicePreviewPdfModalState = {
  pdfFetchState: FetchingState;
  error: any;
};

const initialState: InvoicePreviewPdfModalState = {
  pdfFetchState: { isFetching: false, success: false },
  error: null,
};

const invoicePreviewPdfModalSlice = createSlice({
  name: 'invoices/create/invoicePreviewPdfModal',
  initialState,
  reducers: {
    resetError: state => ({ ...state, error: null }),
    setError: (state, { payload: message }: PayloadAction<string>) => ({
      ...state,
      error: { message },
    }),
  },
  extraReducers: builder => {
    builder.addCase(getInvoicePreviewPdf.pending, state => ({
      ...state,
      pdfFetchState: { isFetching: true, success: false },
      error: null,
    }));
    builder.addCase(getInvoicePreviewPdf.fulfilled, state => ({
      ...state,
      pdfFetchState: { isFetching: false, success: true },
    }));
    builder.addCase(getInvoicePreviewPdf.rejected, (state, { error }) => ({
      ...state,
      pdfFetchState: { isFetching: false, success: false },
      error,
    }));
  },
});

export const {
  actions: { setError, resetError },
  reducer: invoicePreviewPdfModalReducer,
} = invoicePreviewPdfModalSlice;
